import { ActionTypes } from "../constants/ActionTypes";
import { API_ENDPOINTS } from "../../utils/api-endpoints";
import { ReactProjectBaseUrl } from "../../utils/Constants";
import { getApiToken, getBranchToken, isGeofenchingEnabled } from "../../utils/get-token";
import axios from "axios";
import Cookies from "js-cookie";
import { GetWishlist } from "./WishlistActions";

export const getReleatedProducts =
  (categoryId) => async (dispatch, getState) => {
    const token = isGeofenchingEnabled() == 1 ? getBranchToken() : getApiToken()
    const userId = Cookies.get("ID");
    const page = 0;
    const length = 10;
    let response = [];

    await axios
      .get(
        ReactProjectBaseUrl +
          API_ENDPOINTS.FETCH_PRODUCT_LIST +
          "?page=" +
          page +
          "&length=" +
          length +
          "&categorys=" +
          categoryId,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            API_TOKEN: token,
          },
        }
      )
      .then((data) => {
        if (data) {
          dispatch(GetWishlist(userId));
          response = data.data;
        }
      });
    const productResponse = response.response;
    let productList = [];
    let allProductCount = 0;

    if (productResponse) {
      productList = productResponse.ecommerceResponse;
      allProductCount = productResponse.count;
    }

    dispatch({ type: ActionTypes.SET_RETALED_PRODUCTS, payload: productList });
  };
